export function defaultBadgeState(id: string): BadgeState {
  return { id, status: 'unknown' };
}

export type BadgeState = {
  id: string;
} & StatusWithDate;

type StatusWithDate = {
  status: 'earned',
  date: Date
} | {
  status: 'unknown' | 'not-earned'
};
